//////////////////////////////////////////////
//! APP BAR CLASS
//////////////////////////////////////////////

NavBar = function(dispatcher) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	
	
//--------------------------------------------
//! Vars
//--------------------------------------------
	this.dispatcher = dispatcher;
	this.isOpen = false;
	this.isActive = false;


//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////
};

NavBar.prototype = {


	constructor: NavBar,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){

		this.bindEvents();
	
	},

    /*---------------------------------------------------
		FUNCTIONS TO CALL EXTERNALLY
	--------------------------------------------------*/
	
	bindEvents : function(){
		
		//Open Close the NavBar
		this.dispatcher.addEventListener(EVENTS.PAGE_CLOSEING, this.close.bind(this));
		this.dispatcher.addEventListener(EVENTS.PAGE_OPENING, this.open.bind(this));
		this.dispatcher.addEventListener(EVENTS.PAGE_OPENED, this.makeReady.bind(this));
		
		$(dom.navBar.prime.link).click( this.clicked.bind( this ) );
		
		//UPDATE LINKS
		//this.dispatcher.addEventListener(EVENTS.PAGE_CLOSEING, this.close.bind(this));
		//this.dispatcher.addEventListener(EVENTS.PAGE_OPENED, this.changePrimary.bind(this));
		
	},
	
	clicked:function(event){
		
		event.preventDefault();

		var href = $(event.target).attr( 'href' );
		if( href === 'submitMessage' ) {
			//alert('submit');
			app.submitMessage();
			
		} else {
			//alert('pageChange')
			page.change(href);
			
		}
		console.log(href)
		if(href === "share"){
			var data = {
				message : app.userMessage,
				type : 1
			};

			this.dispatcher.dispatch( EVENTS.SHARE_IMAGE, data );
		}
		
	

		this.dispatcher.dispatch( EVENTS.TAB_SOUND );
	},
	
	open: function(event) {
		if ((page.tracking.current === 'write' && page.tracking.previous === 'explore') || (page.tracking.current === 'share' && page.tracking.previous === 'share-error') ) {	
			this.aniIn();
		}
	}, 
	
	close:function(event){
		
		//Deactivate status
		this.status('active', false);
		
		//Check need to animate Out
		if ((page.tracking.current === 'explore' && page.tracking.previous === 'write' ) || (page.tracking.current === 'explore' && page.tracking.previous === 'share' ) || (page.tracking.current === 'share-error' && page.tracking.previous === 'share' ) ) {
			this.aniOut();
		}
		
		//Check if need to remove Home btn
		if (page.tracking.previous === 'share') {
			//this.removeHome();
		}
		
	},
	
	makeReady: function(event) {
		
		
		if(this.isOpen) {
			this.setBack();
			this.changePrimary();
			
			if ( page.tracking.current == 'share' && this.isOpen) {
				//this.addHome();
			}
			
			setTimeout(function(){
				this.status('active', true);
			}.bind(this), 150);
		}
		
	},
	
/*---------------------------------------------------
	FUNCTIONS 
--------------------------------------------------*/
	
	status:function(state, bool){
		
		if (state === 'show') {
			if (bool) {
				$(dom.navBar.bar).addClass('is-shown');
			} else {
				$(dom.navBar.bar).removeClass('is-shown');
			}
			this.isOpen = bool;
		}
		else if (state === 'active') {
			if (bool) {
				$(dom.navBar.bar).addClass('is-active');
				
				ani.changePrimeIn.seek(0).play();
				
			} else {
				$(dom.navBar.bar).removeClass('is-active');
				
				ani.changePrimeOut.seek(0).play();	
			}
			this.isActive = bool;
		}
	},
	
	//Chnages back button links
	setBack:function(){
		
		var backPage;
		
		switch(page.tracking.current) {
			case 'write':
				backPage = 'explore';
			break;
			case 'preview':
				backPage = 'write';
			break;
			case 'share':
				backPage = 'preview';

		}
		
		$(dom.navBar.back).attr('href', backPage);
	},
	
	changePrimary:function(){
		
		//Stop clicks
		var label, link;
		
		switch(page.tracking.current) {
			case 'write':
				label = localisation.navBar.preview.copy;
				link = 'submitMessage';
			
			break;
			case 'preview':
				label = localisation.navBar.share.copy;
				link = 'share';
				
			break;
			case 'share':
				label = localisation.navBar.explore.copy;
				link = 'explore';
			break;
		}
		
		$(dom.navBar.prime.link).attr('href', link);
		$(dom.navBar.prime.label).html(label);
		
			
		
		
	},
	
	aniIn:function() {
		
		if (!this.isOpen) {
			
			this.status('show', true);
			ani.appbarIn.seek(0).play()
		}
		
	},
	
	aniOut: function(){
		//animate navbar
		if (this.isOpen) {
			//alert('aniOut');
			ani.appbarOut.seek(0).play()
			this.isOpen = false;
		} else {
			NavBar.shown(false);
		}
	},
	
	addHome: function() {
		//alert('addHome '+ page.tracking.current)
		//Check for correct page
		if (page.tracking.current === 'share' ) {
			var homeIn = new TimelineMax({delay:0, repeat:0});
			//alert('home button animating');
			homeIn
				.to($(dom.navBar.home), 0.25, 
					{alpha: 1,	x: 0,	ease:Power4.easeOut}
				) 
				.set($(dom.navBar.home), {pointerEvents:'all'})
			;
		}
		
	},
	
	removeHome: function() {
		
		if (page.tracking.current !== 'share') {
			var homeOut = new TimelineMax({ delay : 0, repeat : 0 });
			homeOut
				.to($(dom.navBar.home), 0.25, {alpha: 0, x: -50}) 
				.set($(dom.navBar.home), {pointerEvents:'none'})
			;
		}
	}

};



/*

TweenMax.to(myObj,2,{x:100,onComplete:this.doSomething.bind(this) })


//////////////////////////////////////////////
//! 
//////////////////////////////////////////////

var NavBar = {
	
	isOpen: false,
	
	init:function(){
		
	},
	
	//Check what to do when clicked
	clicked:function(href){
		
		if( href === 'submitMessage') {
			//alert('submit');
			app.submitMessage();
			
		} else {
			//alert('pageChange')
			page.change(href);
			
		}
	},
	
	shown:function(bool){
		
		if (bool) {
			$(dom.NavBar.bar).addClass('is-shown');
			NavBar.isOpen = true;
		} else {
			$(dom.NavBar.bar).removeClass('is-shown');
			NavBar.isOpen = false;
		}
		pageAnimate.in();
	},
	
	aniOut: function(){
		//animate navbar
		if (NavBar.isOpen) {
			
			var navbarOut = new TimelineMax({delay:0, repeat:0, onComplete:NavBar.shown, onCompleteParams:[false]});
			
			navbarOut
				.set($(dom.NavBar.bar), {className: '-=is-active'})//deactivate pointer-events
				.to($(dom.NavBar.back), 0.25, {alpha: 0, x: +50, ease:Power4.easeOut})
				.to($(dom.NavBar.home), 0.25, {alpha: 0, x: -50, ease:Power4.easeOut})
				.to($(dom.NavBar.bar+ ' .btn--app'), 0.25, {alpha: 0, y: -30, ease:Power4.easeOut})
			;
		} else {
			NavBar.shown(false);
		}
	},
	
	aniIn:function(delay, showHome){
		
			
			if (!NavBar.isOpen) {
					//alert();
					NavBar.shown(true);
					
					var navbarIn = new TimelineMax({delay:0, repeat:0});
					
					navbarIn
						.set($(dom.NavBar.home), {alpha: 0, x: +50, pointerEvents:'none'}) //Setup home button Animation
						.set( $(dom.NavBar.prime.ele),{clearProps: 'all'})
						.set( $(dom.NavBar.back),{clearProps: 'all'})
						.from($(dom.NavBar.prime.ele), 0.25, {alpha: 0, y: +30, ease:Power4.easeOut})
						.from($(dom.NavBar.back), 0.25, {alpha: 0, x: +50, ease:Power4.easeOut})
						.set($(dom.NavBar.bar), {className: '+=is-active'})//activate pointer-events
						.set( $(dom.NavBar.prime.ele),{clearProps: 'all'})
						.set( $(dom.NavBar.back),{clearProps: 'all'})
					;
			} else if (page.tracking.current === 'share' && NavBar.isOpen) {
				showHome();
			} else {
				NavBar.shown(true);
			}
			
			
	},
	
	anihome:function(){
		var homeIn = new TimelineMax({delay:0.25, repeat:0,});
					
			homeIn
				.to($(dom.NavBar.home), 0.25, {alpha: 1, x: 0, ease:Power4.easeOut})
				.set( $(dom.NavBar.home),{clearProps: 'all'})
				.set( $(dom.NavBar.home),{pointerEvents:'all'})
			;
	},
	
	//Chnages back button links
	setBack:function(){
		
		var backPage;
		
		switch(page.tracking.current) {
			case 'write':
				backPage = 'explore';
			break;
			case 'preview':
				backPage = 'write';
			break;
			case 'share':
				backPage = 'preview';

		}
		
		$(dom.NavBar.back).attr('href', backPage);
	},
	
	changePrimary:function(event){
		
		//Stop clicks
		
		
		var label, link;
		
		switch(page.tracking.current) {
			case 'write':
				label = localisation.NavBar.preview.copy;
				link = 'submitMessage';
			
			break;
			case 'preview':
				label = localisation.NavBar.share.copy;
				link = 'share';
				
			break;
			case 'share':
				label = localisation.NavBar.writenew.copy;
				link = 'write';
			break;
		}
		
		var swapBtn = function(){
			
			$(dom.NavBar.prime.link).attr('href', link);
			$(dom.NavBar.prime.label).html(label);
			
		}
		
		
		
		var changePrime = new TimelineMax({delay:0, repeat:0});
		
		changePrime
			.set($(dom.NavBar.bar), {className: '-=is-active'})
			.fromTo($(dom.NavBar.prime.label), 0.25, 
				{alpha:1, 	transform: 'rotateX(0deg)' }, 
				{alpha: 0, 	transform: 'rotateX(90deg)'})
			.add(swapBtn, 0.25)
			.fromTo($(dom.NavBar.prime.label), 0.25, 
				{alpha:0, 	transform: 'rotateX(-90deg)'}, 
				{alpha: 1, 	transform: 'rotateX(0deg)'})
			.set($(dom.NavBar.bar), {className: '+=is-active'})
		;
		
	}
}*/